import { APIConfiguration } from '@savgroup-front-common/configuration';
import { COMMON_QUERY_PARAMS } from '@savgroup-front-common/constants';
import { SUPPORTED_METHODS } from '@savgroup-front-common/constants/shared';
import { prepareResponseFailure } from '@savgroup-front-common/core/helpers';
import { apiCall } from '@savgroup-front-common/core/services';
import {
  BackResponse,
  BackResponseFailure,
} from '@savgroup-front-common/types';

import { BusinessReturnEligibilityResultDto } from './startOrContinueBusinessReturnCommand';

// eslint-disable-next-line max-len
const ENDPOINT = `${APIConfiguration.owner}sellers/${COMMON_QUERY_PARAMS.SELLER_ID}/businessReturns/${COMMON_QUERY_PARAMS.ORDER_REFERENCE}/product`;

interface RemoveProductToBusinessReturnCommandPayload {
  sellerId: string;
  orderReference: string;
  modelId: string;
  batchQuantity?: number;
}

export const removeProductToBusinessReturnCommand = async ({
  modelId,
  batchQuantity,
  orderReference,
  sellerId,
}: RemoveProductToBusinessReturnCommandPayload): Promise<
  BackResponse<BusinessReturnEligibilityResultDto> | BackResponseFailure
> => {
  try {
    return await apiCall<BackResponse<BusinessReturnEligibilityResultDto>>(
      ENDPOINT.replace(COMMON_QUERY_PARAMS.SELLER_ID, sellerId).replace(
        COMMON_QUERY_PARAMS.ORDER_REFERENCE,
        orderReference,
      ),
      {
        method: SUPPORTED_METHODS.DELETE,
        json: {
          modelId,
          batchQuantity,
        },
      },
    );
  } catch (error) {
    return prepareResponseFailure(error);
  }
};
